// extracted by mini-css-extract-plugin
export default {"quoteInfo":"QuoteInside_quoteInfo__Bwghx","quoteInfoItem":"QuoteInside_quoteInfoItem__FVLnV"};